import { render, staticRenderFns } from "./WheelioTemplate.vue?vue&type=template&id=ef38694a"
import script from "./WheelioTemplate.vue?vue&type=script&lang=ts"
export * from "./WheelioTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports